import { jwtDecode } from "jwt-decode";

export const getAuthData = () => {
    const token = localStorage.getItem("access_token");
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);

        return {
            token,
            userId: parseInt(decoded.sub),
            vendedorId: decoded.vendedor_id,
            supervisorId: decoded.supervisor_id,
            administradorId: decoded.administrador_id,
            rol: decoded.rol,
            username: decoded.username,
            email: decoded.email,
        };
    } catch (error) {
        console.error("Token inválido", error);
        return null;
    }
};